<template>
  <div>
    <hshead title="任务中心" bgcolor="#fff" page="true" pic="false"></hshead>
    <div class="order-ul">
      <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
        <div class="order-li" v-for="(item, index) in list" :key="index">
          <div class="content-box">
            <div class="content-top">
              <div class="left-img">
                <img :src="StaticWebSite + '/' + item.storeLogoUrl" alt v-if="item.storeLogoUrl" />
                <img src="~@/assets/images/order/icon.png" alt v-else />
              </div>
              <div class="center-p">
                <div class="center-p-h1">{{item.storeFullName}}</div>
                <div class="center-p-p">{{item.createTimeTip}}</div>
              </div>
              <div class="right-icon">
                <router-link :to="`/Store/OrderDetail?orderId=${item.id}`">
                  <img src="~@/assets/images/order/ellipsis.png" alt />
                </router-link>
              </div>
            </div>
            <div class="content-content">
              <div class="left-p">
                {{item.productName}}
                <span>({{item.shootValue}}张)</span>
              </div>
              <div class="right-p">¥{{item.totalMoney.toFixed(2)}}</div>
            </div>
            <div class="content-iconp iconp1">{{item.shootHotelName}}</div>
            <div class="content-iconp iconp2">{{item.shootAddress}}</div>
            <div class="content-iconp iconp3" v-if="item.productShootType != 1">{{item.createTime}}</div>
          </div>
          <div class="content-content">
            <!-- <router-link to class="li-btn">我要接单</router-link> -->
            <!-- <div style="font-size:initial;">{{item.orderUserName}}（{{item.orderUserMobile}}）</div> -->
            <!-- <div>
              <van-button plain hairline type="info" size="mini" @click="handleTaskCancel(item)" v-if="item.orderStatus <= 8">拒单</van-button>
              <van-button plain hairline type="info" size="mini" @click="handleReplaceGrapher(item)" v-if="item.orderStatus <= 6">派单</van-button>
            </div>-->
          </div>
          <div class="order-li-bt" v-if="item.orderStatus <= 8 || item.orderStatus <= 6">
            <van-button
              class="this-btn btn1"
              @click="handleTaskCancel(item)"
              v-if="item.orderStatus <= 8"
            >拒单</van-button>
            <van-button
              class="this-btn btn2"
              @click="handleReplaceGrapher(item)"
              v-if="item.orderStatus <= 6"
            >派单</van-button>
          </div>
        </div>
      </van-list>
      <div v-if="finished" class="emptyDataDiv">
        <div v-if="list.length==0">
          <van-icon name="info" />
          <p>暂无任务</p>
        </div>
        <div v-else>没有更多了</div>
      </div>
    </div>
   <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span style="color:#304378">任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_earnings.active : icon_earnings.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <!-- <van-tabbar-item to="Grapher" icon="manager-o">
        <span>摄影师</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_cameraman.active : icon_cameraman.inactive
            "
          />
        </template>
      </van-tabbar-item> -->

      <van-tabbar-item to="Product" icon="orders-o">
        <span>商品管理</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_product.active : icon_product.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">
        <span>更多</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_more.active : icon_more.inactive
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    
    <div class="ref-box" @click="listQuery.pn=1;list=[];getMyTaskOrderPager()">
      <img src="~@/assets/images/order/Refresh.png" alt />
    </div>

    <!-- 拒单 -->
    <van-dialog
      v-model="dialogTaskCancelFormVisible"
      title="填写取消原因"
      show-cancel-button
      :beforeClose="beforeClose"
      @confirm="taskCancelData"
    >
      <van-cell-group name>
        <van-field v-model="reason" type="textarea" placeholder="请输入取消原因" rows="3" autosize></van-field>
      </van-cell-group>
    </van-dialog>

    <!-- 派单 -->
    <van-dialog
      v-model="dialogReplaceGrapherFormVisible"
      title="指派摄影师"
      :beforeClose="beforeClose"
      @confirm="replaceGrapher"
      style="width:100%;height:100%;top:50%;"
      class="replacerapher"
      @load="onLoadByGrapher"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div
        class="dialog-lshoot-close"
        @click="dialogReplaceGrapherFormVisible = !dialogReplaceGrapherFormVisible"
      >
        <van-icon name="close" size="0.7rem"/>
      </div>
      <br />
      <div>
        <van-cell-group>
          <!-- <van-field v-model="listQueryByGrapher.photoGrapherName" label="名称" placeholder="摄影师名称" />
          <van-field
            v-model="listQueryByGrapher.mobile"
            label="手机"
            placeholder="手机号码"
            @focus="onFocus"
          />
          <van-number-keyboard
            v-model="listQueryByGrapher.mobile"
            :maxlength="11"
            :show="showNumberKeyboard"
            close-button-text="完成"
            theme="custom"
            @blur="showNumberKeyboard = false"
          />
          <van-cell>
            <van-button type="info" size="large" class="my-btn" @click="getGrapherPagerBySearch">搜索</van-button>
          </van-cell>-->
          <van-search
            v-model="listQueryByGrapher.photoGrapherName"
            placeholder="请输入摄影师名称 / 手机号码"
          ></van-search>
        </van-cell-group>
        <div class="grapher-ul">
          <van-radio-group v-model="radioByGrapher">
            <van-list
              v-model="loadingByGrapher"
              :finished="finishedByGrapher"
              finished-text="没有更多了"
            >
              <div class="grapher-li" v-for="(item, index) in listByGrapherDynamic" :key="index">
                <div>
                  <van-radio
                    :name="item.id"
                    checked-color="#07c160"
                    @click="replaceGrapher"
                  >{{item.photoGrapherName}}（{{item.mobile}}）</van-radio>
                </div>
              </div>
              <div style="text-align:center;padding-top:10px;">
                <van-button
                  plain
                  type="primary"
                  size="small"
                  @click="getGrapherPagerByMore"
                  v-if="!finishedByGrapher"
                >点击加载更多</van-button>
              </div>
            </van-list>
          </van-radio-group>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Toast, Tabbar, TabbarItem, List, Button, Dialog, CellGroup, Cell, Field, NumberKeyboard, RadioGroup, Radio, Icon, Search } from "vant";
import { getMyTaskOrderPager, cancelTaskOrder, getGrapherPagerByOrder, replaceGrapher } from "@/api/m/store";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//摄影师
import cameraman_icon from "@/assets/images/center/nav-3.png";
import cameraman_icon_act from "@/assets/images/center/nav-3-act.png";
//商品管理
import product_icon from "@/assets/images/center/nav-4.png";
import product_icon_act from "@/assets/images/center/nav-4-act.png";
//更多
import more_icon from "@/assets/images/center/nav-5.png";
import more_icon_act from "@/assets/images/center/nav-5-act.png";

export default {
  name: "MissionHall",
  data() {
    return {
      StaticWebSite: window.StaticWebSite,
      active: 0,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        pn: 1,
        ps: 10
      },
      curSelectedRow: null,
      // 拒单
      dialogTaskCancelFormVisible: false,
      reason: "",
      // 指派摄影师
      showNumberKeyboard: false,
      radioByGrapher: null,
      dialogReplaceGrapherFormVisible: false,
      listByGrapher: [],
      listByGrapherDynamic: [],
      loadingByGrapher: false,
      finishedByGrapher: false,
      listQueryByGrapher: {
        pn: 1,
        ps: 1000
      },
      icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_cameraman: {
        active: cameraman_icon_act,
        inactive: cameraman_icon,
      },
      icon_product: {
        active: product_icon_act,
        inactive: product_icon,
      },
      icon_more: {
        active: more_icon_act,
        inactive: more_icon,
      },
    };
  },
  methods: {
    onLoad() {
      this.getMyTaskOrderPager();
    },
    onLoadByGrapher() {
      this.getGrapherPager();
    },
    //列表数据
    getMyTaskOrderPager() {
      // this.listQuery.OrderStatus = 1; //下单状态
      getMyTaskOrderPager(this.listQuery)
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getMyTaskOrderPager -> data", data);
            this.listQuery.pn = this.listQuery.pn + 1;
            //
            if (data.totalRecord == 0) {
              this.loading = false;
              this.finished = true;
            } else {
              data.list.map(item => {
                this.list.push(item);
              });
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.list.length >= data.totalRecord) {
                this.finished = true;
              }
            }
          }
        })
        .catch(response => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    beforeClose(action, done) {
      if (action == "cancel") done();
      else done(false);
    },
    /************* 拒单（取消任务） *************/
    handleTaskCancel(row) {
      console.info("handleTaskCancel", row);
      this.curSelectedRow = row;
      this.reason = "";
      this.dialogTaskCancelFormVisible = true;
    },
    taskCancelData() {
      console.info("taskCancelData", this.reason, this.curSelectedRow);

      if (this.reason == "") {
        this.tips(`请输入取消原因`);
        return false;
      }

      this.load(true, "加载中...");
      let para = {
        ids: [this.curSelectedRow.id],
        reason: this.reason
      };
      cancelTaskOrder(para)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            this.dialogTaskCancelFormVisible = false;
            //this.getList();
            this.curSelectedRow.orderStatus = 10;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    /************* 派单（指派摄影师） *************/
    onFocus() {
      this.showNumberKeyboard = true;
    },
    //摄影师列表数据
    getGrapherPager() {
      this.listQueryByGrapher.orderId = this.curSelectedRow.id;
      getGrapherPagerByOrder(this.listQueryByGrapher)
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getGrapherPager -> data", data);
            //
            if (data.totalRecord == 0) {
              this.loadingByGrapher = false;
              this.finishedByGrapher = true;
            } else {
              data.list.map(item => {
                this.listByGrapher.push(item);
              });
              this.listByGrapherDynamic = this.listByGrapher
              // 加载状态结束
              this.loadingByGrapher = false;
              // 数据全部加载完成
              if (this.listByGrapher.length >= data.totalRecord) {
                this.finishedByGrapher = true;
              }
            }
          }
        })
        .catch(response => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //打开层
    handleReplaceGrapher(row) {
      console.info("ReplaceGrapher", row);
      this.curSelectedRow = row;
      this.dialogReplaceGrapherFormVisible = true;
      if (this.listByGrapher.length == 0) this.getGrapherPager();
    },
    //搜索
    getGrapherPagerBySearch() {
      this.listQueryByGrapher.pn = 1;
      this.listByGrapher = [];
      this.finishedByGrapher = false;
      this.getGrapherPager();
    },
    //加载更多
    getGrapherPagerByMore() {
      this.listQueryByGrapher.pn = this.listQueryByGrapher.pn + 1;
      this.getGrapherPager();
    },
    //
    replaceGrapher() {
      console.info("replaceGrapher", this.radioByGrapher);
      const grapher = this.listByGrapher.filter(
        w => w.id == this.radioByGrapher
      )[0];
      const message = `是否确认将订单\n【${this.curSelectedRow.productName}】\n指派给摄影师\n【${grapher.photoGrapherName}】`;
      Dialog.confirm({
        title: "确认操作",
        message: message
      })
        .then(() => {
          // on confirm
          const param = {
            Id: this.curSelectedRow.id,
            GrapherId: grapher.id
          };
          console.info("param", param);
          replaceGrapher(param)
            .then(response => {
              this.load(false);
              const { code, msg, data } = response;
              if (code >= 0) {
                this.tips(`操作成功`);
                this.dialogReplaceGrapherFormVisible = false;
              }
            })
            .catch(response => {
              this.load(false);
              //this.tips(response.msg);
              Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
            });
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  components: {
    hshead,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-list": List,
    "van-button": Button,
    //"van-dialog": Dialog.Component,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-number-keyboard": NumberKeyboard,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-icon": Icon,
    "van-search": Search
  },
  watch: {
    'listQueryByGrapher': {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        // let self = this;
        // self.getGrapherPagerBySearch()
        //console.info('watch', val, oldVal)
        this.listByGrapherDynamic = this.listByGrapher.filter(w => w.photoGrapherName.indexOf(val.photoGrapherName) > -1 || w.mobile.indexOf(val.photoGrapherName) > -1)
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.order-ul {
  margin-top: -6.2rem;
  .order-li {
    width: 6.7rem;
    background-color: #ffffff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    position: relative;
    .content-box {
      padding: 0.47rem 0.3rem;
      border-bottom: 1px solid #e5e5e5;
      .content-top {
        display: flex;
        margin-bottom: 0.15rem;
        .left-img {
          padding-right: 0.2rem;
          width: 0.62rem;
          img {
            width: 0.62rem;
            height: 0.62rem;
          }
        }
        .center-p {
          width: 4.6rem;
          padding-bottom: 0.4rem;
          .center-p-h1 {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 0.28rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0rem;
            color: #666666;
          }
          .center-p-p {
            height: 0.21rem;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.4rem;
            letter-spacing: 0rem;
            color: #00bbfb;
          }
        }
        .right-icon {
          flex: 1;
          img {
            width: 0.64rem;
            height: 0.64rem;
            background-color: #ffffff;
          }
        }
      }
      .content-content {
        display: flex;
        .left-p {
          width: 100%;
          font-family: PingFangSC-Medium;
          font-size: 0.3rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #222222;
          span {
            font-size: 0.28rem;
          }
        }
        .right-p {
          flex: 1;
          text-align: right;
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        margin-bottom: 0.4rem;
      }
      .content-iconp {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.24rem;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.5rem;
        margin-top: 0.2rem;
        word-break: break-all;
        &.iconp1 {
          background: url(~@/assets/images/order/1.png) left center no-repeat;
          background-size: 0.2rem 0.22rem;
        }
        &.iconp2 {
          background: url(~@/assets/images/order/2.png) left center no-repeat;
          background-size: 0.19rem 0.24rem;
        }
        &.iconp3 {
          background: url(~@/assets/images/order/3.png) left center no-repeat;
          background-size: 0.22rem 0.21rem;
        }
      }
    }
    .li-btn {
      position: absolute;
      bottom: 0.4rem;
      right: 0.3rem;
      width: 1.7rem;
      height: 0.6rem;
      border-radius: 0.3rem;
      border: solid 1px #00b8f5;
      font-size: 0.24rem;
      text-align: center;
      color: #00b8f5;
      line-height: 0.6rem;
      &:active {
        background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
          linear-gradient(#f2f9fb, #f2f9fb);
        background-blend-mode: normal, normal;
        color: #fff;
      }
    }
    .order-li-bt {
      height: 1.17rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .this-btn {
        width: 1.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        border: solid 1px #00b8f5;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.6rem;
        letter-spacing: 0rem;
        color: #00b8f5;
        text-align: center;
        display: block;
        margin: 0 0.3rem;
        &.btn1 {
        }
        &.btn2 {
          background-color: #00b8f5;
          color: #fff;
        }
      }
    }
  }
}
.van-dialog__content {
  padding-top: 10px;
}
.replacerapher .van-dialog__content {
  height: 80%;
}
.grapher-ul {
  width: 100%;
  height: 65%;
  overflow: scroll;
  position: absolute;
  .van-list {
    width: 100%;
  }
  .grapher-li {
    border: 1px solid #f0f6ef;
    padding: 0.2rem 0px;
    font-size: 0.28rem;
  }
  .van-loading {
    display: none;
  }
}
.dialog-lshoot-close {
  position: fixed;
  top: 0.2rem;
  right: 0.2rem;
  color: #ff0000;
}
.my-btn {
  border-radius: 1rem !important;
  background-color: #00b8f5 !important;
  font-size: 14px !important;
  border-color: transparent;
  height: 35px;
  line-height: 35px;
}
.ref-box{
  position: fixed;
  right: 0.2rem;
  bottom: 1.2rem;
  opacity: 0.3;
  img{
    width: 1rem;
  }
  &:active{
    opacity: 0.6;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/store/MissionHall.vue